import React, { useState, useEffect } from "react";
import { auth, firestore, storage } from "../utils/firebase";
import { useHistory } from "react-router-dom";
import { useRef } from "react";

const AdminPanel = () => {
  const history = useHistory();

  const puanSistem = useRef();
  const hasOnlyMenu = useRef();

  useEffect(() => {
    let name;
    auth.onAuthStateChanged((user) => {
      if (!user) {
        history.push("/login");
      }
    });
  }, []);
  
  const uploadLogo = async (image) => {
    try {
      const task = await storage.ref(`shortName/${image.name}`).put(image);
      return await task.ref.getDownloadURL();
    } catch (error) {
      console.error("Logo upload failed:", error);
      throw error;
    }
  };

  const createRestaurantInfo = async (shortName, logoUrl) => {
    try {
      await firestore.collection(`Restaurants/${shortName}/info`).doc("info").set({
        color,
        name,
        logo: logoUrl,
        welcomeText,
        hasUserSystem: puanSistem.current.checked,
        hasOnlyMenu: hasOnlyMenu.current.checked,
      });
    } catch (error) {
      console.error("Failed to create restaurant info:", error);
      throw error;
    }
  };

  const initializeRestaurantCollections = async (shortName) => {
    try {
      const collections = [
        { path: `Restaurants/${shortName}/info/tables`, data: {} },
        { path: `Restaurants/${shortName}/orders/order`, data: {} },
        { path: `Restaurants/${shortName}/orders/waiter`, data: {} },
        { path: `Restaurants/${shortName}/users/demo`, data: {} },
      ];

      await Promise.all(
        collections.map(({ path, data }) =>
          firestore.doc(path).set(data)
        )
      );
    } catch (error) {
      console.error("Failed to initialize collections:", error);
      throw error;
    }
  };

  const createAdminUser = async (shortName, password) => {
    try {
      const email = `${shortName}@dba.com`;
      await auth.createUserWithEmailAndPassword(email, password);
      await firestore.collection("Admin").doc(email).set({ restaurant: shortName });
      await auth.signInWithEmailAndPassword(email, password);
    } catch (error) {
      console.error("Failed to create admin user:", error);
      throw error;
    }
  };

  const resetForm = () => {
    setWelcomeText("");
    setShortName("");
    setName("");
    setLogo("");
    setColor("");
    setPassword("");
  };

  const create = async () => {
    try {
      // Create initial restaurant document
      await firestore
        .collection("Restaurants")
        .doc(shortName)
        .set({ Menu: [] }, { merge: true });

      // Upload logo and get URL
      const logoUrl = await uploadLogo(image);

      // Create restaurant info
      await createRestaurantInfo(shortName, logoUrl);

      // Initialize all required collections
      await initializeRestaurantCollections(shortName);

      // Create user document
      await firestore
        .collection("Users")
        .doc(shortName)
        .set({ email: `${shortName}@dba.com` });

      // Create admin user and sign in
      await createAdminUser(shortName, password);

      // Reset form and show success message
      resetForm();
      alert("Başarılı");
      
      // Navigate to admin panel
      history.push("/admin");
    } catch (error) {
      console.error("Restaurant creation failed:", error);
      alert("Bir hata oluştu. Lütfen tekrar deneyin.");
    }
  };

  const [welcomeText, setWelcomeText] = useState("Hoş Geldiniz");
  const [shortName, setShortName] = useState("");
  const [name, setName] = useState("");
  const [logo, setLogo] = useState("");
  const [color, setColor] = useState("");
  const [password, setPassword] = useState("");
  const [image, setImage] = useState("");
  return (
    <div className="row">
      <div className="col-3">
        <div
          className="btn btn-info m-5"
          onClick={() => {
            auth.signOut();
          }}
        >
          Çıkış Yap
        </div>
      </div>

      <div className="col-6" style={{ fontSize: "0.8vw" }}>
        <form>
          <p style={{ marginTop: 50, textAlign: "center", fontWeight: "bold" }}>
            Yeni Restoran oluştur
          </p>
          <div className="form-group w-50 mx-auto">
            <label for="exampleFormControlInput1">Kısa Adı</label>
            <input
              type="text"
              className="form-control"
              value={shortName}
              placeholder="Linklerde gözükecek ve kullanıcı adı olacak."
              onChange={(e) => {
                setShortName(e.target.value);
              }}
            />
          </div>
          <div className="form-group w-50 mx-auto">
            <label for="exampleFormControlInput1">Restoran Adı</label>
            <input
              type="text"
              className="form-control"
              value={name}
              onChange={(e) => {
                setName(e.target.value);
              }}
            />
          </div>
          <div className="form-group w-50 mx-auto">
            <label for="exampleFormControlInput1">Logo</label>
            <input
              type="file"
              onChange={(e) => {
                setImage(e.target.files[0]);
              }}
            />
          </div>
          <div className="form-group w-50 mx-auto">
            <label for="exampleFormControlInput1">Renk</label>
            <input
              type="text"
              className="form-control"
              value={color}
              placeholder="renk hex değeri"
              onChange={(e) => {
                setColor(e.target.value);
              }}
            />
          </div>
          <div className="form-group w-50 mx-auto">
            <label for="exampleFormControlInput1">Menu girişteki text</label>
            <input
              type="text"
              className="form-control"
              value={welcomeText}
              onChange={(e) => {
                setWelcomeText(e.target.value);
              }}
            />
          </div>
          <div className="form-group w-50 mx-auto">
            <label for="exampleFormControlInput1">
              Panele Girişte Kullanılacak Şifre
            </label>
            <input
              type="password"
              className="form-control"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
              }}
            />
          </div>
          <div className="form-group w-50 mx-auto">
            <input id="mPuan" type="checkbox" ref={puanSistem} />
            <label for="mPuan">Kullanıcı Puan Sistemi Olsun mu</label>
          </div>
          <div className="form-group w-50 mx-auto">
            <input id="cMenu" type="checkbox" ref={hasOnlyMenu} />
            <label for="cMenu">Sadece Menü</label>
          </div>

          <div className="row">
            <div
              className="btn btn-primary w-25 mx-auto mt-5"
              onClick={() => {
                create();
              }}
            >
              Kaydet
            </div>
          </div>
        </form>
      </div>
      <div className="col-3"></div>
    </div>
  );
};

export default AdminPanel;
